import axios from 'axios'
import config from '../config'
import { generateToken } from './auth.service'
const axiosInstance = axios.create({
    baseURL: config.REACT_APP_API_URL as string,
    timeout: config.REACT_APP_API_TIMEOUT as unknown as number, // request timeout
    headers: {
        'Content-Type': 'application/json',
        // 'Access-Control-Allow-Origin': '*',
    },
})
export const ExemptedEndpoints = ['/forgot-password']

// request interceptor
axiosInstance.interceptors.request.use(
    (config: any) => {
        // do something before request is sent
        const token = localStorage.getItem('userToken')
        let isExempted = !!ExemptedEndpoints.find(
            (item) => config.url.indexOf(item) !== -1
        )
        if (token && !isExempted) {
            config.headers['Authorization'] = `Bearer ${token}` || ''
        }
        return config
    },
    (error) => {
        // do something with request error
        return Promise.reject(error)
    }
)

// response interceptor
axiosInstance.interceptors.response.use(
    /**
     * Determine the request status by custom code
     * Here is just an example
     * You can also judge the status by HTTP Status Code
     */
    (response) => {
        if (response.data && response.data.error) {
            return Promise.reject(response)
        }

        return response.data
    },
    async (error) => {
        // 401: redirect to login
        if (error?.response?.status === 401) {
            try {
                localStorage.removeItem('userToken')
                await generateToken()

                const token = localStorage.getItem('userToken')
                let isExempted = !!ExemptedEndpoints.find(
                    (item) => error.config.url.indexOf(item) !== -1
                )
                if (token && !isExempted) {
                    error.config.headers['Authorization'] =
                        `Bearer ${token}` || ''
                }

                return axiosInstance.request(error.config)
            } catch (err) {
                console.log('err :', err)
            }
        }
        return Promise.reject(error)
    }
)

export default axiosInstance
